import { render, staticRenderFns } from "./UploadAuth.vue?vue&type=template&id=7a127338&scoped=true&"
import script from "./UploadAuth.vue?vue&type=script&lang=js&"
export * from "./UploadAuth.vue?vue&type=script&lang=js&"
import style0 from "./UploadAuth.vue?vue&type=style&index=0&id=7a127338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a127338",
  null
  
)

export default component.exports